import {
    AfterViewInit,
    Directive,
    ElementRef, EventEmitter, HostBinding,
    Input, OnChanges, OnDestroy, OnInit, Output,
    Renderer2, SimpleChanges
} from "@angular/core";
import {MainHelper} from "../models/main-helper";
import {PopoverOption} from "bootstrap";
import {BTControl} from "../../stocks/models/b-t-control";
import {TranslateService} from "@ngx-translate/core";
import {VDShowType} from "../models/v-d-show-type";
import {b} from "@angular/core/src/render3";

@Directive({
    selector: '[valPp]'
})
export class ValidationDirective implements OnInit, AfterViewInit, OnDestroy, OnChanges{
    constructor(public elementRef: ElementRef, public readonly renderer: Renderer2, private readonly translateService: TranslateService){
        this.helper = new MainHelper();
        this.input = elementRef.nativeElement;
        this.listenerInput = this.renderer.listen(this.input, 'input', e => this.validate(e));
        this.listenerChange = this.renderer.listen(this.input, 'change', e => this.validate(e));
        this.listenerFocus = this.renderer.listen(this.input, 'focus', e => {this.focused = true; this.setOutline()});
        this.listenerFocus = this.renderer.listen(this.input, 'blur', e => {this.focused = false; this.setOutline()});
        this.emit = new EventEmitter<boolean>();
        this.emitFull = new EventEmitter<Slick.ValidateResults>();
        this.validated = true;

    }

    // @HostBinding('class')
    private wrongClass: string;

    @HostBinding('style.outline')
    private hostOutline: string;

    @Input('valPp')
    set setContainer(validationFunction: (val, item?, editor?, outerData?: any) => Slick.ValidateResults){
        if (!validationFunction){
            return;
        }

        this.validationFunction = validationFunction;
    }

    @Input('valControl') private control?: BTControl;
    @Input() private outerData?: any;
    @Input() private showType?: VDShowType;
    @Input('valPlacement') private placement?: string;
    @Input() private testing?: string;

    @Output('vRes') private readonly emit: EventEmitter<boolean>;
    @Output('vResFull') private readonly emitFull: EventEmitter<Slick.ValidateResults>;

    private helper: MainHelper;
    private readonly input: HTMLInputElement;
    private readonly listenerChange: () => void;
    private readonly listenerInput: () => void;
    private readonly listenerFocus: () => void;
    private readonly listenerBlur: () => void;
    private validated: boolean;
    private focused: boolean

    private validationFunction: (val, item?, editor?, outerData?: any) => Slick.ValidateResults;

    ngOnInit(){
        this.showType = this.showType ? this.showType : VDShowType.OnHoverFocus;
    }

    ngAfterViewInit(): void{
        this.control === BTControl.show ? this.helper.wait(this.validate, 1500) : null;
    }

    ngOnChanges(changes: SimpleChanges): void{
        if (!changes['control'] || changes['control'] && changes['control'].firstChange === true){
            return
        }
        if (this.testing){
            console.log(this.testing, changes, 'ngOnChanges 2')
        }


        if (changes['control'].currentValue !== changes['control'].previousValue){
            /*if (changes['control'].currentValue === BTControl.hide){
                this.hideError();
            } else {
                this.validate()
            }*/
            switch (changes['control'].currentValue){
                case BTControl.hide: this.hideError(); break;
                case BTControl.show: this.validate(); break;
                case BTControl.showAgain: this.validate(); break;
                case BTControl.notDisplay: this.validate(); break;
                case BTControl.borderOnly: this.validate(); break;
            }
        } else if (changes['control'].currentValue === changes['control'].previousValue){
            this.validate();
        }
    }

    ngOnDestroy(){
        this.hideError();
        this.listenerInput();
        this.listenerChange();
    }

    private setHostStyles = (set: boolean) => {
        this.wrongClass = set
            ? this.focused
                ? 'not-validated-focused'
                : 'not-validated'
            : null

        const removeClass = (): void => {
            this.renderer.removeClass(this.input, 'not-validated-focused')
            this.renderer.removeClass(this.input, 'not-validated')
        }

        set && this.wrongClass
            ? this.renderer.addClass(this.input, this.wrongClass)
            : removeClass();


        if (this.testing){
            console.log(this.testing, this.input, this.wrongClass)
        }


        this.setOutline();
    }

    private setOutline = (): void => {
        this.hostOutline = this.focused
            ? this.validated
                ? 'auto'
                : 'none'
            : 'none';
    }

    private validate = (e?): void => {

        if (this.testing){
            console.log(this.validationFunction, this.testing, e ? e.target.value: 'target null', this.input.value, 'validate')
        }

        if (!this.validationFunction){
            return;
        }

        if (this.testing){
            console.log(this.testing, e ? e.target.value: 'target null', this.input.value, 'validate 2')
        }


        this.helper.wait(() => {
            let result = this.validationFunction(e ? e.target.value : this.input.value, null, null, this.outerData);
            this.validated = result.valid;
            result.valid ? this.hideError() : this.showError(result.msg);
            this.emitFull.emit(result);
        }, 250)
    }

    private showError = (error: string): void => {
        this.hideError(false);

        const getTrigger = (): 'manual' | 'hover' | 'focus' | 'hover focus' => {
            switch (this.showType){
                case VDShowType.Always: return 'manual';
                case VDShowType.OnHover: return 'hover';
                case VDShowType.OnFocus: return 'focus';
                case VDShowType.OnHoverFocus: return 'hover focus';
            }
        }

        if (this.testing){
            console.log(this.testing, getTrigger(), 'showError 2')
        }

        if (this.control !== BTControl.notDisplay){
            if (this.control !== BTControl.borderOnly){
                this.translateService.get(error).subscribe(t => {
                    const jqInput = $(this.input);
                    const placement = this.placement ? this.placement : 'auto'
                    const popoverId = jqInput
                        .popover({container: 'body', content: t, placement: placement, trigger: getTrigger()} as PopoverOption)
                        .popover('show')
                        .attr('aria-describedby');
                    $(`#${popoverId}`).addClass('popover-danger');
                })
            }

            this.setHostStyles(true);
        }

        this.emit.emit(false);
    }

    private hideError = (emit: boolean = true): void => {
        if (this.testing){
            console.log(this.testing, 'hide 2')
        }
        $(this.input).popover('hide').popover('dispose');
        emit && this.emit.emit(true);
        this.setHostStyles(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/validation.directive.ts